export enum LoadingStatusTruck {
    LOAD_INIT = 'LOAD_INIT',
    LOAD_START = 'LOAD_START',
    LOAD_END = 'LOAD_END',
  }

export const LoadingStatusTruckLabels: Record<LoadingStatusTruck, string> = {
    [LoadingStatusTruck.LOAD_INIT]: 'Enregistrée',
    [LoadingStatusTruck.LOAD_START]: 'En cours',
    [LoadingStatusTruck.LOAD_END]: 'Chargée',
};